import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUserGraduate,
  FaMoneyBillWave,
  FaUserCog,
  FaSignOutAlt
} from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const AgentSidebar = ({ closeSidebar }) => {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();

  const handleLogout = () => {
    logoutUser();
    navigate("/");
    closeSidebar && closeSidebar();
  };

  return (
    <div
      className="bg-side text-white d-flex flex-column dashboard-side-panel"
    >
      <div className="p-3">
        <h4 className="text-center mb-4">Agent Panel</h4>

        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <NavLink
              to="/agent/dashboard"
              className="nav-link text-white"
              onClick={closeSidebar}
            >
              <FaTachometerAlt className="me-2" />
              Dashboard
            </NavLink>
          </li>

          <li className="nav-item mb-2">
            <NavLink
              to="/agent/students"
              className="nav-link text-white"
              onClick={closeSidebar}
            >
              <FaUserGraduate className="me-2" />
              Students
            </NavLink>
          </li>
          <li className="nav-item mb-2">
            <NavLink
              to="/agent/commissions"
              className="nav-link text-white"
              onClick={closeSidebar}
            >
              <FaMoneyBillWave className="me-2" />
              Commissions
            </NavLink>
          </li>
          <li className="nav-item mb-2">
            <NavLink
              to="/agent/profile"
              className="nav-link text-white"
              onClick={closeSidebar}
            >
              <FaUserCog className="me-2" />
              Profile
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="p-3 ">
        <button
          onClick={handleLogout}
          className="btn btn-danger w-100 d-flex align-items-center justify-content-center"
        >
          <FaSignOutAlt className="me-2" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default AgentSidebar;
